import React, { useState } from 'react';
import { Box, Button, Heading, Span, Text, VStack, HStack } from '@bpba/ui-components';
import { Queries } from '../rest/Queries';
import { useFieldArray, useForm, SubmitHandler } from 'react-hook-form';
import { ctaPersonaJuridicaModel } from '../rest/models/CtaPersonaJuridicaModel';
import { ValidarCuitPersonaJuridica } from "../rest/models/ValidarCuitPersonaJuridica";
import { postEsClientePersonaJuridica } from '../rest/mutations/postEsClientePersonaJuridica';
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';
import { useMutation, useQuery } from '@apollo/client';
import { Mutations } from '../rest/Mutations';
import { Localidad } from '../rest/models/Localidad';
import { Sucursal } from '../rest/models/Sucursal';
import { getLocalidadesCDNI } from '../rest/queries/getLocalidadesCDNI';
import { getLocalidadesSuc } from '../rest/queries/getLocalidadesSuc';
import { getSucursales } from '../rest/queries/getSucursales';
import { getPartidosSuc } from '../rest/queries/getPartidosSuc';
import { Partido } from '../rest/models/Partido';
import { CtaPersonaJuridicaRQ } from '../rest/models/CtaPersonaJuridicaRQ';
import { postCtaPersonaJuridica } from '../rest/mutations/postCtaPersonaJuridica';
import { SpinnerCajas } from '../pages/Spinner/SpinnerCajas';
import { Result } from './Result';
import { useNavigate } from 'react-router-dom';
import { ResultError } from './ResultError';
import { PERSONA_JURIDICA_BANNER } from '../Constantes';
import { ResultExito } from './ResultExito';

const validateRealCuit = (cuit: string) => {
    let rv = false;
    if (cuit.length === 8 || cuit.length === 7) {
        const validarDni = /^[0-9]{1,3}\.?[0-9]{3,3}\.?[0-9]{3,3}$/;
        rv = validarDni.test(cuit)
    }
    else {
        let resultado = 0;
        const codes = "6789456789";
        let verificador = parseInt(cuit[cuit.length - 1]);
        let x = 0;

        while (x < 10) {
            let digitoValidador = parseInt(codes.substring(x, x + 1));
            if (isNaN(digitoValidador)) digitoValidador = 0;
            let digito = parseInt(cuit.substring(x, x + 1));
            if (isNaN(digito)) digito = 0;
            let digitoValidacion = digitoValidador * digito;
            resultado += digitoValidacion;
            x++;
        }
        resultado = resultado % 11;
        rv = resultado === verificador;
    }
    return rv ? rv : "Verifique el Cuit ingresado";
};

const ComponenteCtaPersonaJuridicaPresolicitud: React.FC = () => {


    const [servicioOk, setServicioOk] = useState<boolean>(false);
    const [errorServicio, setErrorServicio] = useState<boolean>(false);
    const [mensajeError, setMensajeError] = useState<string>("");
    const { register, control, handleSubmit, resetField, reset, formState: { errors } } = useForm<any>({
        mode: 'onChange',
        criteriaMode: 'all',
        reValidateMode: 'onChange',
        defaultValues: {
            apoderado: [{ nombre: '', cuit: undefined }]
        }
    });
    const [showFullForm, toggleFullForm] = useState<boolean>(false);
    const REQUIRED_FIELD = "Campo requerido.";
    const mailValidator = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/;
    const numberValidator = /^\d+$/;

    const { fields, append, remove } = useFieldArray({
        control,
        name: 'apoderado'
    });


    function BuscLoc(formId: string) {
        setIdProvinciaCDNI(formId.split('-')[0]);

    }
    function BuscPartidosSuc(formId: string) {
        setIdProvinciaSuc(formId.split('-')[0]);
        setIdPartidoSuc('');
        setIdLocalidadSuc('');
        resetField('localidadSuc');
        resetField('sucursal');
    }

    function BuscLocSuc(formId: string) {
        setIdPartidoSuc(formId.split('-')[0]);
        if (formId === '') {
            setIdLocalidadSuc('');

        }
        resetField('localidadSuc');
        resetField('sucursal');
    }
    function BuscSuc(formId: string) {
        setIdLocalidadSuc(formId.split('-')[0]);
        resetField('sucursal');
    }


    const { executeRecaptcha } = useGoogleReCaptcha();
    const [postValidarCuitApi, { loading: loadingValidarCuit }] = useMutation<Mutations>(postEsClientePersonaJuridica);
    const [tokenCuit, setTokenCuit] = useState("");
    const [showCheck, setShowCheck] = useState<boolean>(false);

    const ValidarCuit = async (data: ctaPersonaJuridicaModel) => {
        const token = executeRecaptcha && (await executeRecaptcha('ValidarCuit'));
        let datos: ValidarCuitPersonaJuridica = {
            "cuit": data.cuit.toString(),
            "apoderados": data.apoderado,
            "googleToken": token,
            "sistema": "cuentajuridica",
            "linea": ""
        }

        postValidarCuitApi({ variables: { input: datos } }).then((response: any) => {

            if (response.data!.esClientePersonaJuridica.baseNegativa) {
                setTokenCuit(response.data!.esClientePersonaJuridica.token);
                setMensajeError("");
                toggleFullForm(true);

            } else {
                setErrorServicio(true);
                setMensajeError("No es posible continuar con la carga de la presolicitud de apertura de la cuenta.Por favor dirigite a la sucursal a fin de obtener mayor información de los motivos de rechazo.");
            }
        }).catch((e: any) => {
            if (e.networkError.statusCode === 500) {
                setErrorServicio(true);
                setMensajeError("Ha ocurrido un problema, inténtelo mas tarde.");

            }
            else if (e.networkError.statusCode === 409) {
                if (JSON.parse(JSON.stringify(e.networkError)).result.Message !== "Hubo un error al simular en el core bancario. Disculpe las molestias") {
                    setServicioOk(true);
                    setMensajeRtaServicio(JSON.parse(JSON.stringify(e.networkError)).result.Message);
                }
                setErrorServicio(true);
                setMensajeError(JSON.parse(JSON.stringify(e.networkError)).result.Message);
            } else {

                setMensajeError("Ha ocurrido un problema, inténtelo mas tarde.");
            }
        })
    }
    const [idProvinciaCDNI, setIdProvinciaCDNI] = useState<string>();
    const [idProvinciaSuc, setIdProvinciaSuc] = useState<string>();
    const [idLocalidadSuc, setIdLocalidadSuc] = useState<string>();
    const [idPartidoSuc, setIdPartidoSuc] = useState<any>();
    const { data: { localidades } = {} } = useQuery<Queries>(getLocalidadesCDNI, { variables: { idProvincia: idProvinciaCDNI }, skip: !idProvinciaCDNI });
    const { data: { localidadesSuc } = {} } = useQuery<Queries>(getLocalidadesSuc, { variables: { idPartido: idPartidoSuc }, skip: !idPartidoSuc });
    const { data: { partidosSuc } = {} } = useQuery<Queries>(getPartidosSuc, { variables: { idProvincia: idProvinciaSuc }, skip: !idProvinciaSuc });
    const { data: { sucursales } = {} } = useQuery<Queries>(getSucursales, { variables: { idLocalidadSuc: idLocalidadSuc, filterBranch: 1 }, skip: !idLocalidadSuc });
    const [ctaPersonaJuridica, { loading: loadingPostCtaPersonaJuridica }] = useMutation<Mutations>(postCtaPersonaJuridica);
    let search = window.location.search;
    let params = new URLSearchParams(search);
    let origenSolicitud = params.get('origenSolicitud');
    const [mensajeRtaServicio, setMensajeRtaServicio] = useState<React.ReactNode>(<></>);
    const [adjuntar, setAdjuntar] = useState(false);
    const [nroSolicitud, setNroSolicitud] = useState(0);
    const [mensajeErrorPostProspecto, setMensajeErrorPostProspecto] = useState<string>("");
    const navigate = useNavigate();

    const onSubmit: SubmitHandler<ctaPersonaJuridicaModel> = async (data: ctaPersonaJuridicaModel) => showFullForm ? SubmitForm(data) : ValidarCuit(data)


    const SubmitForm: SubmitHandler<ctaPersonaJuridicaModel> = async (data: ctaPersonaJuridicaModel) => {


        let datos: CtaPersonaJuridicaRQ = {
            "token": tokenCuit,
            "cuit": Number(data.cuit),
            "razonSocial": data.razonSocial,
            "email": data.email,
            "telefonoContacto": (data.telefonoArea + data.telefono).toString(),
            "sucursal": Number(data.sucursal),
            "localidad": data.provincia.split('-')[1] + "," + data.localidad + " " + data.calle + "," + data.numeroCalle + "," + data.piso,
            "origenSolicitud": origenSolicitud ? origenSolicitud : "",
            "archivo": "file",
            "tipoSociedad": Number(data.tipoSociedad),
        }
        ctaPersonaJuridica({ variables: { input: datos } }).then(response => {

            if (response.data?.ctaPersonaJuridica.token) {
                setServicioOk(true);
                setAdjuntar(true)
                setNroSolicitud(response.data?.ctaPersonaJuridica.nroSolicitud);
                setMensajeRtaServicio(<><Text fontSize={"20px"} margin={0} fontWeight={600}>A través de la opción “Adjuntar”, podés enviar copia digitalizada del Contrato Social, Estatuto y DNI de los socios.</Text><Text fontSize={"16px"} margin={0}>Podrás cargar los siguientes formatos : image/gif, image/jpg, image/jpeg, image/png, txt, csv, bmp, tiff,pdf,docx (tamaño máximo 1MB).</Text></>);
            } else {
                setServicioOk(true);
                setMensajeRtaServicio("Ha ocurrido un problema, inténtelo mas tarde.");
            }
        }).catch((e) => {

            if (e.networkError.statusCode === 500) {
                setServicioOk(false);
                setMensajeErrorPostProspecto("Ha ocurrido un problema, inténtelo mas tarde.");

            }
            else if (e.networkError.statusCode === 409) {
                setServicioOk(false);
                setMensajeErrorPostProspecto(JSON.parse(JSON.stringify(e.networkError)).result.Message);

            } else {
                setServicioOk(false);
                setMensajeErrorPostProspecto("Ha ocurrido un problema, inténtelo mas tarde.");
            }
        })


    }

    if (loadingValidarCuit || loadingPostCtaPersonaJuridica) return <SpinnerCajas />;

    const handleRedirect = () => {

        navigate('/DocumentacionAdjunta', {
            state: {
                nroSolicitud: nroSolicitud,
                banner: PERSONA_JURIDICA_BANNER,
                titulo: "Contratación Semipresencial de Cuentas Para Personas Juridicas",
                masDeUnArchivo: true
            }
        });
    };

    const handleReset = () => {
        reset({});
        window.location.reload();
    };
    if (adjuntar) return (
        <VStack>
            <VStack>
                <Text fontSize={"22px"} lineHeight={"27px"} fontWeight={"400"} color={"primary.0"}>{mensajeRtaServicio}</Text>
                <VStack style={{ justifyContent: 'space-between', display: 'flex', flexDirection: 'row' }}>
                    <VStack mr={"0.5rem"}>
                        <Button
                            onClick={() => { setAdjuntar(false); setServicioOk(true); setMensajeRtaServicio("En los próximos días nos contactaremos con vos."); }}
                            variant="secondary"
                            py={"10px !important"}
                            style={{
                                width: "100%",
                                height: "calc(1.8em + 0.75rem + 2px)"
                            }}
                        >
                            Finalizar
                        </Button>
                    </VStack>
                    <VStack mr={"0.5rem"}>
                        <Button
                            onClick={() => handleRedirect()}
                            variant="secondary"
                            py={"10px !important"}
                            style={{
                                width: "100%", backgroundColor: "white",
                                borderRadius: "3px 8px 3px 8px",
                                border: "solid 2px", borderColor: "#3c3c3b",
                                color: "#3c3c3b",
                                height: "calc(1.8em + 0.75rem + 2px)"
                            }}
                        >
                            Adjuntar
                        </Button>
                    </VStack>
                </VStack>
            </VStack>
        </VStack>
    );
    if (servicioOk) return (
        <Result handleReset={handleReset}>
            <VStack>
                <Heading level={2} fontWeight={400} color="primary.0" tabIndex={0}>{mensajeRtaServicio}</Heading>
            </VStack>
        </Result>
    );
    if (mensajeErrorPostProspecto !== "" && !servicioOk) return (
        <Result handleReset={handleReset}>
            <ResultError message={mensajeErrorPostProspecto}></ResultError>
        </Result>
    );

    return (

        <Box>
            <VStack>
                <form noValidate onSubmit={handleSubmit(onSubmit)} style={{ minHeight: '400px', display: "flex", flexDirection: "column", marginBottom: "4rem" }}>

                    <Heading level={3} mb={'20px'} fontWeight={400} tabIndex={0}>
                        Datos Generales
                    </Heading>
                    {errorServicio ?
                        <VStack>
                            <Span color="red" fontSize={"12px"} tabIndex={0}>
                                {mensajeError}
                            </Span>
                        </VStack> : <></>
                    }

                    {(!showFullForm) ? <>
                        <Span mt={"20px"} color="primary.0" fontSize={"14px"} style={{ lineHeight: "18px" }}>
                            Persona Jurídica
                        </Span>
                        <input type={"text"} tabIndex={0}
                            {...register("cuit", {
                                required: REQUIRED_FIELD, pattern: { value: numberValidator, message: "El campo debe ser numérico" }, minLength: { value: 11, message: "cantidad minima de caracteres: 11" },
                                maxLength: 11, validate: (value) => validateRealCuit(value.toString())
                            })}
                            name='cuit' id='cuit' placeholder='CUIT ej: 30123456789' maxLength={11} minLength={11} />
                         <Span fontSize={"12px"} tabIndex={0}>
                         *ingresar el CUIT sin guiones
                        </Span>
                        <Span color="red" fontSize={"12px"} tabIndex={0}>
                            {errors.cuit ? "* " + errors.cuit.message : ""}
                        </Span>

                        <Span mt={"20px"} color="primary.0" fontSize={"14px"} style={{ lineHeight: "18px" }}>
                            Apoderado / Representante legal / Firmante de la Persona Jurídica
                        </Span>
                        {fields.map((item, index) => (
                            <VStack mt={"8px"}>
                                <Box key={`apoderado-${index}`} display={'flex'}>

                                    <Box id={`apoderado-${index}`} justifyContent={'space-between'} display={'flex'} flexDirection={'row'}>
                                        <VStack mr={"0.5rem"}>
                                            <input id={`nombre-${item.id}`}  {...register(`apoderado.${index}.nombre`, { required: REQUIRED_FIELD, maxLength: 25 })} type="text" placeholder='Nombre Completo' maxLength={25} style={{paddingRight: "5px"}} />
                                            <Span color="red" fontSize={"12px"} tabIndex={0}>{errors.apoderado && errors.apoderado[index]?.nombre ? "* " + errors.apoderado[index]?.nombre.message : ""}</Span>
                                        </VStack>
                                        <VStack mr={"0.5rem"}>
                                            <input id={`cuit-${item.id}`} {...register(`apoderado.${index}.cuit`, { required: REQUIRED_FIELD, maxLength: 11, minLength: { value: 11, message: "cantidad minima de caracteres: 11" }, validate: (value) => validateRealCuit(value.toString()) })}
                                                maxLength={11} minLength={11} type="text" placeholder='CUIT/CUIL' />
                                            <Span color="red" fontSize={"12px"} tabIndex={0}>{errors.apoderado && errors.apoderado[index]?.cuit ? "* " + errors.apoderado[index]?.cuit.message : ""}</Span>
                                        </VStack>
                                    </Box>
                                    <Button style={{ backgroundColor: '#cb3a3a', width: '30%', height: "calc(1.8em + 0.75rem + 2px)" }} id={`btn-${item.id}`} type="button" variant={'primary'} onClick={() => remove(index)} mt={'14px !important'} py={'10px !important'}>Eliminar</Button>

                                </Box>
                            </VStack>
                        ))}
                        <Box justifyContent={"center"}>
                            <Button style={{ width: "fit-content", height: "calc(1.8em + 0.75rem + 2px)" }} id={`btn-+`} type="button" variant={'primary'} onClick={() => append({ nombre: '', cuit: undefined })} py={'10px !important'}>Agregar persona</Button>

                        </Box>
                        <Button variant='secondary' style={{ bottom: '0', transition: 'all .1s ease-out', padding: '8px 12px', alignSelf: 'center', fontSize: '17px' }} tabIndex={0} id="botonEnviar" type='submit'>Validar</Button>

                    </> :
                        <>
                            {errorServicio ?
                                <VStack>
                                    <Span color="red" fontSize={"12px"} tabIndex={0}>
                                        {mensajeError}
                                    </Span>
                                </VStack> : <></>
                            }
                            <VStack>
                                <input {...register(`razonSocial`, { required: REQUIRED_FIELD, maxLength: 100 })} name='razonSocial' type={"text"} defaultValue={""} placeholder='Razón social' maxLength={100} />
                                <Span color="red" fontSize={"12px"} tabIndex={0}>{errors.razonSocial ? "* " + errors.razonSocial.message : ""}</Span>
                            </VStack>

                            <VStack mt={"20px"}>
                                <input type={'text'} {...register("email", { required: REQUIRED_FIELD, pattern: { value: mailValidator, message: "Formato de email inválido ejemplo: juana@mail.com" } })} name="email" placeholder='E-mail' maxLength={100} />
                                <Span color="red" fontSize={"12px"} tabIndex={0}>{errors.email ? "* " + errors.email.message : ""}</Span>
                            </VStack>

                            <VStack style={{ justifyContent: 'space-between', display: 'flex', flexDirection: 'row' }} mt={"20px"}>
                                <VStack mr={"0.5rem"}>
                                    <select tabIndex={0} aria-label={"Por favor, Seleccione el tipo de sociedad"}
                                        style={{ width: "100%" }}
                                        {...register("tipoSociedad", { required: REQUIRED_FIELD })}
                                        name="tipoSociedad" placeholder='tipoSociedad' onClick={(e: any) => e.target.value === "2" ? setShowCheck(true) : setShowCheck(false)} >
                                        <option value="">Seleccione el tipo de sociedad</option>
                                        <option value="4">Sociedades Comerciales previstas en la Ley 19550</option>
                                        <option value="3">Asociaciones Civiles</option>
                                        <option value="5">Consorcios de Propietarios</option>
                                        <option value="8">Cooperadoras Escolares / Otras Asociaciones Cooperadoras</option>
                                        <option value="2">Cooperativas</option>
                                        <option value="6">Entidades no oficiales e Instituciones Religiosas</option>
                                        <option value="9">Fundaciones</option>
                                        <option value="1">Mutuales</option>
                                        <option value="7">Sociedades Irregulares</option>
                                    </select>
                                    <Span color="red" fontSize={"12px"} tabIndex={0}>{errors.tipoSociedad ? "* " + errors.tipoSociedad.message : ""}</Span>
                                </VStack>

                            </VStack>
                            <VStack mt={"20px"}>
                                <Span color="primary.0" fontSize={"14px"} style={{ lineHeight: "18px" }}>
                                    Teléfono de contacto
                                </Span>
                                <VStack style={{ justifyContent: 'space-between', display: 'flex', flexDirection: 'row' }}>
                                    <VStack mr={"0.5rem"}>
                                        <input style={{ width: "100%" }} {...register("telefonoArea", { required: REQUIRED_FIELD, maxLength: 4, pattern: { value: numberValidator, message: "El campo debe ser numérico" }, })} name="telefonoArea" placeholder='Ej.: 11' maxLength={4} type={"text"} />
                                        <Span color="red" fontSize={"12px"} tabIndex={0}>{errors.telefonoArea ? "* " + errors.telefonoArea.message : ""}</Span>
                                    </VStack>
                                    <VStack>
                                        <input tabIndex={0} style={{ width: "100%" }} {...register("telefono", { required: REQUIRED_FIELD, maxLength: 14, pattern: { value: numberValidator, message: "El campo debe ser numérico" }, })} name="telefono" placeholder='Ej.: 4232424' maxLength={14} type={"text"} />
                                        <Span color="red" fontSize={"12px"} tabIndex={0}>{errors.telefono ? "* " + errors.telefono.message : ""}</Span>
                                    </VStack>
                                </VStack>
                            </VStack>
                            <VStack mt={"20px"}>
                                <Span color="primary.0" fontSize={"14px"} marginBottom={"8px"} style={{ lineHeight: "18px" }} tabIndex={0}>Domicilio Real / Legal </Span>

                                <VStack style={{ justifyContent: 'space-between', display: 'flex', flexDirection: 'row' }}>
                                    <VStack mr={"0.5rem"}>
                                        <select tabIndex={0} aria-label={"Seleccione la provincia para la localidad"}
                                            style={{ width: "100%" }}
                                            {...register("provincia", { required: REQUIRED_FIELD })}
                                            onChange={(e: any) => BuscLoc(e.target.value)} name="provincia" placeholder='Provincia' >
                                            <option value="">Provincia</option>
                                            <option value="2-Buenos Aires">Buenos Aires</option>
                                            <option value="1-Ciudad de Buenos Aires">Ciudad de Buenos Aires</option>
                                        </select>
                                        <Span color="red" fontSize={"12px"} tabIndex={0}>{errors.provincia ? "* " + errors.provincia.message : ""}</Span>
                                    </VStack>
                                    <VStack >
                                        <select tabIndex={0} aria-label={"Seleccione la localidad"} style={{ width: "100%" }} {...register("localidad", { required: REQUIRED_FIELD })} name="localidad" placeholder='Localidad' >
                                            <option value="" selected >Localidad </option>
                                            {localidades &&
                                                localidades.map((item: Localidad) =>
                                                    <option value={item.desc_localidad} key={item.desc_localidad}>{item.desc_localidad}</option>
                                                )}
                                        </select>
                                        <Span color="red" fontSize={"12px"} tabIndex={0}>{errors.localidad ? "* " + errors.localidad.message : ""}</Span>
                                    </VStack>
                                </VStack>


                                <VStack style={{ justifyContent: 'space-between', display: 'flex', flexDirection: 'row' }}>
                                <VStack mr={"0.5rem"} mt={"20px"}>
                                        <input tabIndex={0}{...register("calle", { required: REQUIRED_FIELD, maxLength: 50 })} name="calle" placeholder='Calle' maxLength={50} type={"text"} />
                                        <Span color="red" fontSize={"12px"} tabIndex={0}>{errors.calle ? "* " + errors.calle.message : ""}</Span>
                                    </VStack>
                                    <VStack mr={"0.5rem"} mt={"20px"}>
                                        <input tabIndex={0}{...register("numeroCalle", { required: REQUIRED_FIELD, maxLength: 5, pattern: { value: numberValidator, message: "El campo debe ser numérico" }, })} name="numeroCalle" placeholder='Nro' maxLength={5} type={"text"} />
                                        <Span color="red" fontSize={"12px"} tabIndex={0}>{errors.numeroCalle ? "* " + errors.numeroCalle.message : ""}</Span>
                                    </VStack>
                                    <VStack mt={"20px"}>
                                        <input tabIndex={0}{...register("piso", { required: false, maxLength: 8, })} name="piso" placeholder='Piso' maxLength={8} type={"text"} />
                                        <Span color="red" fontSize={"12px"} tabIndex={0}>{errors.piso?.message}</Span>
                                    </VStack>

                                </VStack>


                            </VStack>
                            <VStack mt={"20px"}>
                                <Span mb={"8px"} color="primary.0" fontSize={"14px"} style={{ lineHeight: "18px" }}>Sucursal en donde querés contratar tu Cuenta</Span>

                                <VStack style={{ justifyContent: 'space-between', display: 'flex', flexDirection: 'row' }}>
                                    <VStack mr={"0.5rem"}>
                                        <select tabIndex={0} aria-label={"Seleccione la provincia para la localidad de la  sucursal"}
                                            {...register("provinciaSuc", { required: REQUIRED_FIELD })}
                                            onChange={(e) => BuscPartidosSuc(e.target.value)} name="provinciaSuc">
                                            <option value="" >Ubicación</option>
                                            <option value="2-Buenos Aires">Buenos Aires</option>
                                            <option value="1-Ciudad de Buenos Aires">Ciudad de Buenos Aires</option>
                                        </select>

                                        <Span color="red" fontSize={"12px"} tabIndex={0}>
                                            {errors.provinciaSuc ? "* " + errors.provinciaSuc.message : ""}
                                        </Span>
                                    </VStack>
                                    <VStack>
                                        <select tabIndex={0} aria-label={"Seleccione el partido de la  sucursal"} {...register("partidoSuc", { required: REQUIRED_FIELD })} onChange={(e) => BuscLocSuc(e.target.value)} name="partidoSuc"
                                        >
                                            <option value="" >Partido</option>
                                            {partidosSuc &&
                                                partidosSuc.map((item: Partido) =>
                                                    <option value={item.id_partido} key={item.desc_partido}>{item.desc_partido}</option>
                                                )}
                                        </select>
                                        <Span color="red" fontSize={"12px"} tabIndex={0}>
                                            {errors.partidoSuc ? "* " + errors.partidoSuc.message : ""}
                                        </Span>
                                    </VStack>
                                </VStack>
                                <VStack mt={"20px"} style={{ justifyContent: 'space-between', display: 'flex', flexDirection: 'row' }}>
                                    <VStack mr={"0.5rem"}>
                                        <select tabIndex={0} aria-label={"Seleccione la localidad de la  sucursal"} {...register("localidadSuc", { required: REQUIRED_FIELD })} onChange={(e) => BuscSuc(e.target.value)} name="localidadSuc"
                                        >
                                            <option value="" >Localidad/barrio</option>
                                            {localidadesSuc &&
                                                localidadesSuc.map((item: Localidad) =>
                                                    <option value={item.id_localidad} key={item.desc_localidad}>{item.desc_localidad}</option>
                                                )}
                                        </select>

                                        <Span color="red" fontSize={"12px"} tabIndex={0}>
                                            {errors.localidadSuc ? "* " + errors.localidadSuc.message : ""}
                                        </Span>
                                    </VStack>
                                    <VStack>
                                        <select tabIndex={0} aria-label={"Seleccione la  sucursal"} style={{ width: "100%" }} {...register("sucursal", { required: REQUIRED_FIELD })} name="sucursal" defaultValue={""}>
                                            <option value="" disabled>Sucursal</option>
                                            {sucursales &&
                                                sucursales.map((item: Sucursal) =>
                                                    <option value={item.cod_ubic} key={item.suc_nombre}>{item.cod_ubic + " - " + item.suc_nombre}</option>
                                                )}
                                        </select>
                                        <Span color="red" fontSize={"12px"} tabIndex={0}>
                                            {errors.sucursal ? "* " + errors.sucursal.message : ""}
                                        </Span>
                                    </VStack>
                                </VStack>

                                {(showCheck) ? <>
                                    <HStack mt={"20px"}>
                                        <Box width={"50%"} alignItems={"baseline"}><input type='checkbox' tabIndex={0} {...register("acepta", { required: REQUIRED_FIELD })} name="acepta" style={{ transform: "scale(1.3)" }} /></Box>
                                        <Text fontSize={"12px"} lineHeight={"18px"} marginLeft={"5px"}>
                                        Autorizo expresamente al BANCO DE LA PROVINCIA DE BUENOS AIRES a compartir la presente presolicitud y los datos de contacto informados a Provincia Microempresas S.A (PROME), y al INSTITUTO PROVINCIAL DE ASOCIATIVISMO Y COOPERATIVISMO (IPAC) de la Provincia de Buenos Aires a los fines de que dicho organismo pueda brindar asistencia respecto de la presentación de la documentación necesaria para la apertura de la cuenta solicitada y para que elabore informes de evaluación y estadística de la gestión, de conformidad a lo dispuesto en los arts. 5 y 11 de la Ley N°25.326, cuyo tenor puede consultarse en (incluir vinculo que dirija al texto de la Ley 25.326). Tomo conocimiento de que ambas entidades se comprometen a mantener el carácter de confidencial de toda la información cedida a la luz de lo dispuesto en la citada ley
                                        </Text>
                                    </HStack>
                                    <Span color="red" fontSize={"12px"} tabIndex={0}>
                                        {errors.acepta ? "* " + errors.acepta.message : ""}
                                    </Span>
                                </>
                                    : <></>}

                                <Button type="submit" variant="secondary" marginBottom={"24px"} style={{ height: "calc(1.8em + 0.75rem + 2px)" }} py={'10px !important'}>Enviar</Button>

                            </VStack>
                        </>


                    }


                </form>
            </VStack>

        </Box>

    )

};



export default ComponenteCtaPersonaJuridicaPresolicitud;